import {Card, Stack} from '@mui/material';
import React from 'react';

import {MainHeader, ProductLogo} from 'presentation/components';

import {translations} from 'presentation/translations-new';
import {AppointmentInfoList} from '../ConfirmationBooking/AppointmentInfoList';
import {SuccessHeader} from '../ConfirmationBooking/SuccessHeader';
import {usePrintTemplate} from './hooks/usePrintTemplate';
import {Container, StyledContainer, StyledLogoContainer, StyledWrapper} from './styles';
import {PrintTemplateProps} from './types';
import {AppointmentAddress} from '../ConfirmationBooking/AppointmentAddress';
import {AppointmentDocumentAlert} from '../ConfirmationBooking/AppointmentDocumentAlert';

const {confirmationBooking} = translations['pt-br'].privateFlow.bookingFlow;

export function PrintTemplateNew({
	bookedAppointment,
	flowType,
	printRef,
	isAdvanceDiagnosticsExam,
}: PrintTemplateProps) {
	const {
		clinicName,
		hour,
		providerName,
		specialtyName,
		protocolNumber,
		date,
		planName,
		beneficiaryName,
		formattedAddress,
		hideAddress,
		hideDocumentAlert,
	} = usePrintTemplate({
		bookedAppointment,
		flowType,
	});

	return (
		<Container ref={printRef}>
			<MainHeader title={confirmationBooking} variant="noActions" />

			<StyledWrapper>
				<StyledLogoContainer>
					<ProductLogo />
				</StyledLogoContainer>
				<StyledContainer>
					<Card elevation={0} sx={{borderRadius: 2, p: 3}}>
						<Stack gap={3}>
							<SuccessHeader flowType={flowType} />

							<AppointmentInfoList
								beneficiaryName={beneficiaryName}
								planName={planName}
								providerName={providerName}
								specialtyName={specialtyName}
								date={date}
								hour={hour}
								protocolNumber={protocolNumber}
								flowType={flowType}
								clinicName={clinicName}
								isAdvanceDiagnosticsExam={isAdvanceDiagnosticsExam}
							/>

							{hideAddress ? null : (
								<AppointmentAddress
									formattedAddress={formattedAddress}
									hideButton
									hideMap
								/>
							)}

							{hideDocumentAlert ? null : <AppointmentDocumentAlert />}
						</Stack>
					</Card>
				</StyledContainer>
			</StyledWrapper>
		</Container>
	);
}
